import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import { createLogger } from "redux-logger";
import rootReducer from "../reducers";

const loggerMiddleware = createLogger();

// włączamy redux_devtools w trybie development
const composeEnhancers =
  process.env.NODE_ENV !== 'production' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose;

//store with redux-logging
export const storeLogging = createStore(
  rootReducer,
  applyMiddleware(thunkMiddleware, loggerMiddleware)
);

const enhancer = composeEnhancers(
  applyMiddleware(thunkMiddleware)
  //applyMiddleware(thunkMiddleware, loggerMiddleware) //store with redux-logging
  // other store enhancers if any
);

export const store = createStore(
  rootReducer,
  enhancer
);

/**
 * NOT USED
 *
 * https://redux.js.org/recipes/configuring-your-store
 *
 * @param {*} initialState
 */
export function configureStoreOLD(initialState) {
  const middlewareEnhancer = applyMiddleware(thunkMiddleware);
  return createStore(rootReducer, initialState, middlewareEnhancer);
}